import React from 'react';
import styled from 'styled-components';
import sharedStyles from '@repo/ui-components/styles';
import Breadcrumb from './Breadcrumb';
import breakpoints from './breakpoints';

const BreadcrumbWrapper = styled.div<{ hideOnMobile: boolean }>`
  padding: 0 1.75rem;
  padding-bottom: 0;

  a,
  svg {
    color: ${({ theme }) => theme.colors.breadcrumbLinkColor};
    font-weight: normal;
    font-size: ${sharedStyles.fontSize.base};
    line-height: 2;
  }
  span {
    color: ${({ theme }) => theme.colors.cardText};
    font-weight: normal;
    font-size: ${sharedStyles.fontSize.base};
    line-height: 2;
  }

  display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'block')};

  @media (min-width: ${breakpoints.lg}) {
    display: block;
  }
`;

export interface BreadcrumbElement {
  link?: string;
  text: string;
}

export interface BreadcrumbWithWrapperProps {
  id?: string;
  elements: BreadcrumbElement[];
  hideOnMobile?: boolean;
}

function BreadcrumbWithWrapper({
  id = '',
  elements,
  hideOnMobile = false,
}: Readonly<BreadcrumbWithWrapperProps>) {
  return (
    <BreadcrumbWrapper id={id} hideOnMobile={hideOnMobile}>
      <Breadcrumb elements={elements} />
    </BreadcrumbWrapper>
  );
}

export default BreadcrumbWithWrapper;
